<div class="esn-nav-item" [class.esn-nav-item--active]="active()" [class.esn-nav-item--sm]="size() === 'sm'">
  @if (icon(); as name) {
    <esn-icon class="esn-nav-item__icon" [class.esn-nav-item__icon--active]="active()" [name]="name" [size]="16" />
  }
  <span class="esn-nav-item__label"><ng-content /></span>
</div>
